<p-toast></p-toast>
<div class="card dropdown-content" style="margin: 5px;">
    <h5><b>{{'UPDATE_MI_COMPONENT_CML_VALIDITY'| translate}}</b></h5>
    <div class="p-fluid p-formgrid grid mt-5">

        <div class="field col-12 md:col-2">
            <label htmlFor="selectCategory">{{'PROGRAMME_NAME'| translate}}</label>
            <div class="grid-item">
                <p-dropdown [options]="program" [(ngModel)]="selectedProgram" (onChange)="onSelectProgram()"
                    placeholder="{{'SELECT_A_PROGRAM'| translate}}" optionLabel="Program_Name"></p-dropdown>
            </div>
        </div>

        <div class="field col-12 md:col-3">
            <label htmlFor="selectCategory">{{'VENDOR_NAME'| translate}}</label>
            <div class="grid-item">
                <p-autoComplete [(ngModel)]="selectedVendor" (onSelect)="onSelectVendor($event)" placeholder="{{'SELECT_VENDOR'| translate}}" id="vendor" [dropdown]="true"
                    [multiple]="false" [suggestions]="filteredVendor" (completeMethod)="filterVendor($event)"
                    field="Name" value="">
                </p-autoComplete>
            </div>
        </div>

        <div class="field col-12 md:col-2">
            <label htmlFor="selectCategory">{{'SELECT_CATEGORY'| translate}}</label>
            <div class="grid-item">
                <p-dropdown [options]="category" [(ngModel)]="selectedCategory" (onChange)="onSelectCategory()"
                    placeholder="{{'SELECT_A_CATEGORY'| translate}}" optionLabel="categoryName"></p-dropdown>
            </div>
        </div>

        <!-- <div class="field col-12 md:col-2">
            <label htmlFor="selectComponent">Select Component</label>
            <div class="grid-item">
                <p-dropdown [options]="component" [(ngModel)]="selectedComponent" (onChange)="onSelectComponent()"
                    placeholder="Select a Component" optionLabel="componentName"></p-dropdown>
            </div>
        </div> -->

        <div class="field col-12 md:col-3">
            <label htmlFor="selectComponent">{{'SELECT_CML_NO'| translate}}</label>
            <div class="grid-item">
                <p-dropdown [options]="cml" [(ngModel)]="selectedCML" (onChange)="onSelectCML()"
                    placeholder="{{'SELECT_CML_NO'| translate}}" optionLabel="cmlNo_cmlValidity"></p-dropdown>
            </div>
        </div>

        <!-- <div class="field col-12 md:col-2">
            <label htmlFor="cmlNo">CML No.</label>
            <div class="grid-item">
                <input type="number" min="1" step="1"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57" title="Numbers only" pInputText
                    [(ngModel)]="enteredCMLNo">
            </div>
        </div> -->

        <div class="field col-12 md:col-2">
            <label htmlFor="selectComponent">{{'NEW_VALIDITY_DATE'| translate}}</label>
            <div class="grid-item">
                <p-calendar [showIcon]="true" [showButtonBar]="true" [(ngModel)]="selectedDate" dateFormat="dd-mm-yy">
                </p-calendar>
            </div>
        </div>


        <div class="field col-11 md:col-2">
            <button (click)="onSubmitCMLValidity()" pButton pRipple type="button" label="{{'SAVE'| translate}}"
                class="p-button-success mt-4 mx-5"
                [disabled]="this.programId == null || this.vendorId == null || this.categoryId == null || this.cmlId == null || this.selectedDate == null"></button>
        </div>
    </div>
</div>